import { Box } from '@mui/material'

import OnboardingQuestionnaireForm from '../../detail/OnboardingQuestionnaireForm'

import { OnboardingProvider } from './_context'

export default function OnboardingQuestionnairePage(): JSX.Element {
  return (
    <OnboardingProvider>
      <Box sx={{ width: '100%', minHeight: '100vh' }}>
        <OnboardingQuestionnaireForm />
      </Box>
    </OnboardingProvider>
  )
}
